import { render, staticRenderFns } from "./projectInfoEdit.vue?vue&type=template&id=952c9a38&scoped=true"
import script from "./projectInfoEdit.vue?vue&type=script&lang=js"
export * from "./projectInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./projectInfoEdit.vue?vue&type=style&index=0&id=952c9a38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c9a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('952c9a38')) {
      api.createRecord('952c9a38', component.options)
    } else {
      api.reload('952c9a38', component.options)
    }
    module.hot.accept("./projectInfoEdit.vue?vue&type=template&id=952c9a38&scoped=true", function () {
      api.rerender('952c9a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/customerOrder/projectInfoEdit.vue"
export default component.exports